import { ROLES_LIST } from '@/js/constants';
export default [{
  name: 'Assessment Report',
  key: 'menu.dp.evaluation_report',
  subname: '',
  href: {
    name: 'AssessmentReport'
  },
  link: '/AssessmentReport',
  roles: [ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.ASSESSMENT_USER, ROLES_LIST.ASSESSMENT_ADMIN]
}, {
  name: 'Admin Assessment Report',
  key: 'menu.dp.admin_evaluation_report',
  subname: '',
  href: {
    name: 'AdminAssessmentReport'
  },
  link: '/AdminAssessmentReport',
  roles: [ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.ASSESSMENT_ADMIN],
  checkDomain: true
}];